export const filters = ($http: HttpApi) => ({
  create: (viewId: string, data: HttpParams['body'] = {}) => $http.$post(`/builder/views/${viewId}/filters`, { body: data }),
  update: (viewId: string, viewFilterId: string, data: HttpParams['body'] = {}) => $http.$patch(`/builder/views/${viewId}/filters/${viewFilterId}`, { body: data }),
});
